class Marquee {
  constructor(elem) {
    this.elem = elem;
    this.speed = parseFloat(elem.getAttribute('data-wf-speed'));
    this.contentWidth = elem.querySelector('.marquee-track').scrollWidth;
    this.tick = this.tick.bind(this);
    this.startTime = null;
    this.distance = null;

    elem.querySelector('.marquee-track').innerHTML += elem.querySelector('.marquee-track').innerHTML;

    window.addEventListener('load', () => {
      window.requestAnimationFrame(this.tick);
    })
  }

  tick(timestamp) {
    if (this.startTime == null) {
      this.startTime = timestamp;
      this.distance = 0;
    }
    let elapsed = timestamp - this.startTime;
    this.distance = (this.speed * elapsed / 1000) % this.contentWidth;
    this.elem.querySelectorAll('.marquee-track, .marquee-track-clone').forEach((track) => {
      track.style.transform = `translate(-${this.distance}px, 0)`
    })
    window.requestAnimationFrame(this.tick);
  }
}
document.querySelectorAll('.marquee').forEach((elem) => {
  new Marquee(elem);
});
